import React, {  Component } from 'react';
import GovernmentDialogTooltip from '../../dialogs/governmentDialog';
import ContactUsDialogTooltip from '../../dialogs/contactUsDialog';
import {Link} from 'react-router';
import { connect } from 'react-redux';

import { routes } from '../../../redux/api/routes';
let { geUrl } = routes;

export default class Footer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showGovernmentDialog: false,
            showContactUsDialog: false
        }
    }

    // showGovernmentDialog(event) {
    //     event.preventDefault();
    //     this.props.fireGTMTag('Footer Government', {
    //         navURL: ''
    //     });
    //     this.setState({showGovernmentDialog: true});
    // }

    handleDialogStatus(flag) {
        this.setState({
            showGovernmentDialog: flag
        });
    }

    showContactUsDialog(event) {
        event.preventDefault();
        this.props.fireGTMTag('Footer Contact Us', {
            navURL: ''
        });
        this.setState({showContactUsDialog: true});
    }

    handleDialogStatusContactUs(flag) {
        this.setState({
            showContactUsDialog: flag
        });
    }

    render() {
        const self = this;
        const year = new Date().getFullYear();
        return (
            <div className='d-none d-sm-block pt-3'>
                {(this.state.showGovernmentDialog)?<GovernmentDialogTooltip handleDialogStatus={this.handleDialogStatus.bind(this)} showDialog={this.state.showGovernmentDialog} />:null}
                {(this.state.showContactUsDialog)?<ContactUsDialogTooltip handleDialogStatus={this.handleDialogStatusContactUs.bind(this)} showDialog={this.state.showContactUsDialog} />:null}
                {/* <div className="footer responsive2017">
                    <div className="row margin-btm-1em">
                        <div className="columns large-7 medium-12 small-12">
                            <div>
                                <h3>Related Sites</h3>
                                <hr />
                                <div className="row">
                                    <div className="columns large-3 medium-4 small-12"><a target="_blank" href="http://www.monogram.com/">Monogram.com</a></div>
                                    <div className="columns large-3 medium-4 small-12"><a target="_blank" href="http://www.buildwithge.com/">BuildWithGE.com</a></div>
                                    <div className="columns large-6 medium-4 small-12"><a target="_blank" href="https://www.geappliancesairandwater.com/ ">GEAppliancesAirandWater.com</a></div>
                                </div>
                                
                                <div className="row">
                                    <div className="columns large-3 medium-4 small-12"><a target="_blank" href="http://www.hotpoint.com/">Hotpoint.com</a></div>
                                    <div className="columns large-3 medium-4 small-12"><a target="_blank" href={geUrl}>GEAppliances.com</a></div>
                                    <div className="columns large-6 medium-4 small-12"><a target="_blank" href="http://www.geprofile.com/">GEProfile.com</a></div>
                                </div>
                                <div className="row">
                                    <div className="columns large-3 medium-4 small-12"><a target="_blank" href="https://www.cafeappliances.com/">CafeAppliances.com</a></div>
                                    <div className="columns large-3 medium-4 small-12"><a target="_blank" href="https://www.haierappliances.com/">HaierAppliances.com</a></div>
                                    <div className="columns large-6 medium-4 small-12"><a target="_blank" href="http://www.shop4ge.com/">Customer Home Ownership Store</a></div>
                                </div>
                            </div>
                        </div>
                        <div className="columns large-5 medium-12 small-12">
                            <div>
                                <h3>Stay Connected with GE Appliances</h3>
                                <hr />
                                <div className="row">
                                    <div className="columns large-6 medium-6 small-6"><a className="footerLinkWithIcon footerLinkWithFacebookIcon" target="_blank" href="http://www.facebook.com/geappliances">Facebook</a></div>
                                    <div className="columns large-6 medium-6 small-6"><a className="footerLinkWithIcon footerLinkWithYouTubeIcon" target="_blank" href="http://www.youtube.com/user/GEAppliances">YouTube</a></div>
                                </div>
                                <div className="row">
                                    <div className="columns large-6 medium-6 small-6"><a className="footerLinkWithIcon footerLinkWithTwitterIcon" target="_blank" href="https://twitter.com/ge_appliances">Twitter</a></div>
                                    <div className="columns large-6 medium-6 small-6"><a className="footerLinkWithIcon footerLinkWithPinterestIcon" target="_blank" href="http://www.pinterest.com/geappliances/">Pinterest</a></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row footerLinks">
                        <div className="columns large-8 medium-12 small-12">
                            <ul>
                                <li><a target="_blank" href={geUrl+"/plcy/tandc2.htm"}>Terms</a> </li>
                                <li><a target="_blank" href={geUrl+"/privacy/privacy_policy.htm"}>Privacy Policy</a> </li>
                                <li><Link to="#" onClick={this.showGovernmentDialog.bind(this)} >Government</Link> </li>
                                <li><a target="_blank" href="http://pressroom.geappliances.com/">Press Room</a> </li>
                                <li><Link to="#" onClick={this.showContactUsDialog.bind(this)} >Contact Us</Link> </li>
                            </ul>
                        </div>
                        <div className="columns large-4 medium-12 small-12 copyright">
                            <p>Copyright 2019 GE Appliances, a Haier company<br/>GE is a trademark of General Electric Company. Manufactured under trademark license.</p>
                        </div>
                    </div>
                </div> */}
                <div className="footer">
                {!self.props.hideFooterInfForPunchOut &&
                    <div className="relatedSites floatLeft">
                        <h3>Related Sites</h3>
                        <hr />
                        <table className="layoutTable">
                            <tbody>
                                <tr>
                                    <td><a target="_blank" href="http://www.monogram.com/">Monogram.com</a></td>
                                    <td><a target="_blank" href={geUrl+"/pro/"}>GEAppliances.com/Pro</a></td>
                                    <td><a target="_blank" href="https://www.geappliancesairandwater.com/ ">GEAppliancesAirandWater.com</a></td>
                                    
                                </tr>
                                <tr>
                                    <td><a target="_blank" href="http://www.hotpoint.com/">Hotpoint.com</a></td>
                                    <td><a target="_blank" href={geUrl}>GEAppliances.com</a></td>
                                    <td><a target="_blank" href="http://www.geprofile.com/">GEProfile.com</a></td>
                                    
                                </tr>
                                <tr>
                                    <td><a target="_blank" href="https://www.cafeappliances.com/">CafeAppliances.com</a></td>
                                    <td><a target="_blank" href="https://www.haierappliances.com/">HaierAppliances.com</a></td>
                                    <td><a target="_blank" href="http://www.shop4ge.com/">Customer Home Ownership Store</a></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                }
                {!self.props.hideFooterInfForPunchOut &&
                    <div className="socialLinks floatRight">
                        <h3>Stay Connected with GE Appliances</h3>
                        <hr />
                        <table className="layoutTable">
                            <tbody>
                                <tr>
                                    <td><a className="footerLinkWithIcon footerLinkWithFacebookIcon" target="_blank" href="http://www.facebook.com/geappliances">Facebook</a></td>
                                    <td><a className="footerLinkWithIcon footerLinkWithYouTubeIcon" target="_blank" href="http://www.youtube.com/user/GEAppliances">YouTube</a></td>
                                </tr>
                                <tr>
                                    <td><a className="footerLinkWithIcon footerLinkWithTwitterIcon" target="_blank" href="https://twitter.com/ge_appliances">Twitter</a></td>
                                    <td><a className="footerLinkWithIcon footerLinkWithPinterestIcon" target="_blank" href="http://www.pinterest.com/geappliances/">Pinterest</a></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                }
                    <div className="clear" />
                    <div className="footerLinks floatLeft">
                        <ul>
                        <li><a target="_blank" href={geUrl+"/privacy/terms.htm"}>Terms</a> </li>
                            <li><a target="_blank" href={geUrl+"/privacy/privacy_center.htm"}>Privacy</a> </li>
                            <li><a target="_blank" href={geUrl+"/privacy/privacy_policy.htm#californiaPrivacyNotice"}>California Privacy Notice</a> </li>
                            <li><a target="_blank" href={geUrl+"/accessibility-statement/"}>Accessibility</a> </li>
                            <li><a target="_blank" href="http://pressroom.geappliances.com/">Press Room</a> </li>
                            <li><Link to="#" onClick={this.showContactUsDialog.bind(this)} >Contact Us</Link> </li>
                        </ul>
                    </div>
                    <div className="clear" />
                </div>
                <div className="footer copyright-container">
                    <div className="copyright floatRight">
                        <p>Copyright {year} GE Appliances, a Haier company<br/>GE is a trademark of General Electric Company. Manufactured under trademark license.</p>
                    </div>
                    <div className="clear" />
                </div>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {state};
};

Footer = connect(mapStateToProps)(Footer);
//export default Footer;



// WEBPACK FOOTER //
// ./src/App/components/common/Footer/index.js